import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const ButtonCreatePDF = ({
                           label,
                           onClick,
                           className,
                           ...rest
                         }) => {
  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={classnames(styles.buttonApprove, className)}
      onClick={handleClick}
      {...rest}
    >
      <span>{label}</span>
    </button>
  );
};

ButtonCreatePDF.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default ButtonCreatePDF;
